(function () {
  var PLACED = false;

  function placeInBar(sw) {
    if (PLACED) return true;

    // Find an element belonging to the announcement bar app.
    var marker = document.querySelector('[class*="ss_announcement_bar_slider"]')
      || document.querySelector('[class*="announcement-locale-"]')
      || document.querySelector('announcement-bar');
    if (!marker) return false;

    // Anchor to the section wrapper (never hidden), NOT the app's locale
    // element (which we hide via CSS).
    var bar = marker.closest('.shopify-section') || marker.parentElement || marker;
    if (!bar) return false;

    bar.style.position = 'relative';
    bar.style.overflow = 'visible';
    bar.style.zIndex = '1002';

    sw.classList.add('cls--in-bar');
    bar.appendChild(sw);
    sw.hidden = false;
    PLACED = true;
    return true;
  }

  function init() {
    var sw = document.getElementById('custom-lang-switcher');
    if (!sw) return;

    placeInBar(sw);

    var trigger = sw.querySelector('[data-cls-trigger]');
    if (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var open = sw.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    document.addEventListener('click', function (e) {
      if (!sw.contains(e.target)) {
        sw.classList.remove('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        sw.classList.remove('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }
    });

    // Retry in case the app bar mounts after this script runs.
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (placeInBar(sw) || tries > 24) clearInterval(iv);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
